import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Close from 'material-ui/svg-icons/navigation/close';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import Moment from 'react-moment';

import Loading from '../components/Loading';

import ConferenceDetail from './ConferenceDetail';
import CompanyDetail from './CompanyDetail';
import API from '../api/ApiTool';

const styles = {
  actions: {
    cursor: 'pointer',
    color: '#3b82f6'
  },
};

function dynamicSort(property) {
  var sortOrder = 1;
  return function (a, b) {    
    const dateA = new Date(a['created']);
    const dateB = new Date(b['created']);

    var resultOfDates = (dateA < dateB) ? -1 : (dateA > dateB) ? 1 : 0;

    return resultOfDates * sortOrder;
  }
}

const HangupReportTable = (props) => {
  return (
    <div>
      <Table style={{backgroundColor: "#0f172a"}}>
        <TableHead>
          <TableRow>
            <TableCell>
              Source
            </TableCell>
            <TableCell>
              Company
            </TableCell>
            <TableCell>
              Destination
            </TableCell>
            <TableCell>
              Called again to the same destination
            </TableCell>
            <TableCell>
              At
            </TableCell>
            <TableCell>
              Conference
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.map((e, i) => {
            return (
              <TableRow
                key={i}
              >
                <TableCell>{e.source}</TableCell>
                <TableCell
                  style={styles.actions}
                  onClick={() => props.companyDetail(e.company_id)}
                >
                  {e.company}
                </TableCell>
                <TableCell>{e.destination}</TableCell>
                <TableCell>{e.re_call_time} secs after</TableCell>
                <TableCell><Moment format="YYYY/MM/DD HH:mm:ss">{e.created}</Moment></TableCell>
                <TableCell
                  style={styles.actions}
                  onClick={() => props.conferenceDetail(e.conference_id)}
                >
                  Detail
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};


class HangupReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      date: moment().format('YYYY-MM-DD'),
      buffer: 5,
      conferenceDetailOpen: false,
      conferenceID: undefined,
      companyDetaillOpen: false,
      companyID: undefined
    };
  }

  fetchData() {
    const date = this.state.date;
    const buffer = this.state.buffer;

    this.setState({ loading: true });

    API.GET(`/reporting/hangup-report/?buffer=${buffer}&date=${date}`)
      .then(response => response.json())
      .then(data => this.setState({ data: data.sort(dynamicSort()) }))
      .then(() => this.setState({ loading: false }))      
  }

  componentDidMount() {
    this.fetchData();
  }

  conferenceDetail(id) {
    this.setState({ conferenceDetailOpen: true });
    this.setState({ conferenceID: id });
  }

  companyDetail(id) {
    this.setState({ companyDetaillOpen: true });
    this.setState({ companyID: id });
  }

  conferenceDetailClose = () => {
    this.setState({ conferenceDetailOpen: false });
  };

  companyDetailClose = () => {
    this.setState({ companyDetaillOpen: false });
  };

  handleDate(value) {
    this.setState({ date: value }, () => {
      this.fetchData();
    });
  }

  handleBuffer(value) {
    this.setState({ buffer: value }, () => {
      this.fetchData();
    });
  }

  render() {
    const { loading, date, buffer, conferenceDetailOpen, companyDetaillOpen } = this.state;

    if (loading) {
      return (
        <Loading />
      );
    }

    return (
      <div>
        <Dialog
          fullScreen
          open={conferenceDetailOpen}
        >
          <AppBar color="default" style={{backgroundColor: '#030712'}}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.conferenceDetailClose} aria-label="Close">
                <Close style={{color: '#e5e7eb'}}/>
              </IconButton>
              <Typography variant="h6" color="inherit" >
                Conference Detail
              </Typography>
            </Toolbar>
          </AppBar>
          <ConferenceDetail id={this.state.conferenceID} left={60}/>
        </Dialog>

        <Dialog
          fullScreen
          open={companyDetaillOpen}
        >
          <AppBar color="default" style={{backgroundColor: '#030712'}}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.companyDetailClose} aria-label="Close">
                <Close style={{color: '#e5e7eb'}}/>
              </IconButton>
              <Typography variant="h6" color="inherit" >
                Company Detail
              </Typography>
            </Toolbar>
          </AppBar>
          <CompanyDetail id={this.state.companyID} left={60}/>
        </Dialog>

        <FormGroup row>
          <TextField
            id="date"
            label="Date"
            type="date"
            defaultValue={date}
            onChange={(event) => this.handleDate(event.target.value)}
          />
          <TextField
            id="buffer"
            style={{marginLeft: '10px'}}
            label="Buffer (in secs)"
            type="text"
            defaultValue={buffer}
            onBlur={(event) => this.handleBuffer(event.target.value)}
          />
        </FormGroup>
        <br />
        <HangupReportTable
          data={this.state.data}
          companyDetail={this.companyDetail.bind(this)}
          conferenceDetail={this.conferenceDetail.bind(this)}
        />
      </div>
    );
  }
}

export default withRouter(HangupReport);



// WEBPACK FOOTER //
// ./src/pages/HangupReport.js